(function ($, document, window) {
	'use strict';

	$(function () {
		$('.js-image-gallery-carousel').each(function () {
			const carousel = $(this);
			const layout = carousel.data('layout');
			const sliderEl = $('.swiper', carousel)[0];
			const navParent = $('.js-image-gallery-carousel-nav', carousel).parent();

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 16,
				slidesPerView: 1,
				centeredSlides: true,
				loop: true,

				pagination: {
					el: $('.js-carousel-nav-pagination', carousel)[0],
					clickable: true,
					renderBullet: function (index, className) {
						return '<span class="carousel-nav__bullet ' + className + '">' + (index + 1) + '</span>';
					},
				},

				navigation: {
					nextEl: $('.js-carousel-nav-next', carousel)[0],
					prevEl: $('.js-carousel-nav-prev', carousel)[0],
				},

				breakpoints: {
					768: {
						slidesPerView: layout === 'small' ? 1.52 : 'auto',
					},
				},

				on: {
					beforeInit: function () {
						let numSlides = this.wrapperEl.querySelectorAll( '.js-carousel-slide' ).length;
						if ( numSlides <= 4 ) {
							this.params.loop = false;
						}
					}
				}
			});
		});
	});
})(jQuery, document, window);